<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <h3>Manual Generate Monthly Fee Invoice (Car Park)</h3>
      
      <AppForm
        ref="pageForm" 
        v-bind:formParameter="PARAM"
        v-bind:permission="permission"
        v-on:form-change="onFormChange" >

      </AppForm>

      <TemplateFeedback ref="pageFeedback" />

      <TemplateButton v-on:click="onSaveButtonClick" class="btn btn-success">
        Submit
      </TemplateButton>

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateModal from "@/components/Template/TemplateModal";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppForm from "@/components/App/AppForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');

const PARAM = [
  {
    key: 'carparkID',
    text: 'Car Park',
    form_select: {
      data: [],
      formatSelectOptionValue: (data) => data.id, 
      formatSelectOptionText: (data) => data.carparkCode ? `${data.carparkCode} - ${data.name}` : data.name,
    },
    form_chosen: true,
  },
  {
    key: '_date',
    text: 'Billing Month',
    form_default: helper.formatDate(new moment().startOf('month').unix()),
    form_datepicker: {
      beforeShowDay: function(date) {
        return date.getDate() === 1;
      },
    },
    form_muted: 'Date of bills will generate according to Next Billing Month',
  },
];

const PARAM_MAP = helper.transformParamToMap(PARAM);

export default {
  name: "PageManualBillCarpark",
  components: {
    TemplateBasic,
    TemplateButton,
    TemplateButton,
    TemplateFeedback,
    TemplateModal,
    AppForm,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Adminstration' },
        { name: 'Manual Generate Monthly Fee Invoice (Car Park)' },
      ],

      PARAM,
      PARAM_MAP,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    this.$refs['pageForm'].setForm(true);
    this.hideFormFromKey('carparkID');
    this.loadCustomer();
  },
  methods: {
    hideFormFromKey(key) {
      this.pageShowAdd = false;
      this.pageShowEdit = false;

      if(key === null) {
        this.pageShowAdd = true;
        this.pageShowEdit = true;
      }

      let hide = false;
      this.PARAM.forEach(parameter => {
        if(parameter.key === key) {
          hide = true;
        }

        if(hide) {
          parameter.form_hide = hide;
          return;
        }

        if(parameter.key === 'accessCard') {
          if(this.$refs['pageForm'].formData['applicationType'] === 'Personal') {
            parameter.form_hide = false;
          } else {
            parameter.form_hide = true;
          }
          return;
        }

        parameter.form_hide = hide;
      });
    },
    loadCustomer() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading profile data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageCustomer = response.data;
          this.loadCarpark();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'profile data'));
        });
    },
    loadCarpark() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading car park data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();

          this.pageCarpark = response.data
          response.data = response.data.filter(k => {
            if(!k['isEnable']) {
              return false;
            }
            if(k['SuspendApplication']) {
              return false;
            }
            if(k['endDate'] && helper.parseDateTime(k['endDate']) <= moment().startOf('day')) {
              return false;
            }
            return true;
          });

          helper.inputSelectSetOption(this.PARAM_MAP['carparkID'], response.data);
          let formData = this.$refs['pageForm'].formData;
          formData['carparkID'] = this.$route.query.carparkID || formData['carparkID'];
          // formData['licenseID'] = this.$route.query.licenseID || formData['licenseID'];
          this.loadLicense();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'car park data'));
        });
    },
    loadLicense() {
      this.hideFormFromKey(null);
      return;
      
      this.hideFormFromKey('licenseID');
      let formData = this.$refs['pageForm'].formData;

      let url = helper.SERVER_URL;
      url += '/api2/carpark/' + formData['carparkID'] + '/license/';

      let feedbackItem = 'parking license data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          let tempData = response.data[0];
          if(tempData) {
            // TODO kw1 only show active license & lease
            if(this.$refs['pageForm'].formIsAdd) {
              response.data = response.data.filter(k => k.status === 'Active');
            }

            this.pageLicense = response.data;

            response.data.forEach(k => {
              k['_carpark'] = this.pageCarpark.find(j => j.id === k.carparkID);
              k['_customer'] = this.pageCustomer.find(j => j.id === k.customerID);
            });

            helper.inputSelectSetOption(this.PARAM_MAP['licenseID'], response.data);
            this.hideFormFromKey(null);

            this.$refs['pageFeedback'].setFeedbackMessage();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'license data'));
        })
    },

    onSaveButtonClick() {

      if(!this.$refs['pageForm'].validateForm()) {
        let formData = this.$refs['pageForm'].formData;
        formData['date'] = helper.parseDateTime(formData['_date']).unix();

        this.$refs['pageFeedback'].setFeedbackLoading('Generating monthly bill');
        this.$http
          .post(
            helper.SERVER_URL + '/api2/license/billingCarpark',
            querystring.stringify(formData),
            helper.createAxiosFormConfig()
          )
          .then(response => {
            let resultMeta = helper.processAxiosResponse(this, response);
            this.$refs['pageFeedback'].setFeedbackMessage('Successfully generate monthly bill on ' + helper.formatDate(formData['_date']));
            return true;
          })
          .catch(error => {
            this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'generating', 'monthly bill'));
          })
      }
    },

    onFormChange(formData, parameter) {
      if(parameter.key === 'carparkID') {
        this.loadLicense();
      }
    },

    hasAddOrEditPermission() {
      if(this.pageIsAdd) {
        return helper.hasAddPermission(this.permission);
      } else {
        return helper.hasEditPermission(this.permission);
      }
    },
    hasDeletePermission() {
      return helper.hasDeletePermission(this.permission);
    },
    
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Manual/PageManualBillCarpark.vue